import { useSelector } from 'react-redux';
import classNames from 'classnames/bind';
import loadable from '@utils/loadable';
import { FAQ } from '../../../../data/realTimeApi';

import withComponentName from '../../../../decorators/withComponentName';
import withMetatag from '../../../../decorators/metadataDecorators/metatagsTitleDecorator';

import Styles from './style.module.scss';

const PricingPlans = loadable(() => import('./PricingPlans'));
const PricingFAQ = loadable(() => import('./PricingFAQ'));
const PricingForm = loadable(() => import('./PricingForm'));
const PricingProvides = loadable(() => import('./PricingProvides'));
const MobileAnchorButtons = loadable(() => import('../../../MobileAnchorButtons'));
const CTAbuttons = loadable(() => import('../../../Header/MainHeaderComponent/CTAbuttons'));

const cx = classNames.bind(Styles);

const APIFinancialNewsPricing = () => {
  const headerHeight = useSelector((state) => state.header.height);
  const searchBarActive = useSelector(({ searchReducers }) => searchReducers.searchBarActive);

  return (
    <div className={cx('Pricing', { pricingpage_blured: searchBarActive })} style={{ paddingTop: `${headerHeight}px` }}>
      { searchBarActive && <div className={cx('overlay')} /> }
      <div className={cx('Pricing__container')}>
        <section className={cx('Pricing__Header')}>
          <h1>Real-time API Pricing Plans</h1>
          <p>
            Data in machine-readable format for better decision making.
          </p>
        </section>

        <PricingProvides />

        <section className={cx('Pricing__Plans')}>
          <PricingPlans />
        </section>

        <section className={cx('Pricing__FAQ')}>
          <PricingFAQ FAQList={FAQ} withFooter />
        </section>

        <section className={cx('Pricing__ContactUs')} id="contactus-form">
          <span className={cx('Pricing__ContactUs--title')}>Contact Us</span>
          <span className={cx('Pricing__ContactUs--sub-title')}>
            We are looking to automate the entire subscription process but for now,
            please contact us to set things up for you.
          </span>
          <PricingForm />
        </section>
      </div>
      <MobileAnchorButtons>
        <CTAbuttons
          contactUsLeadsToForm
          path="/products/api/financial-news/pricing-api/commercial"
          ctaButtonType="mobileAnchorButton"
        />
      </MobileAnchorButtons>
    </div>
  );
};
export default withComponentName(withMetatag(APIFinancialNewsPricing, 'products/api/financial-news/pricing-api'));
